/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgOption = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M11 19h2v2h-2zm0-4h2v2h-2zm-4 0h2v2H7zm8-12h2v2h-2zm-4 0h2v2h-2zM7 3h2v2H7zm0 16h2v2H7zm-4-6h18V7H3v6zm2-4h14v2H5V9zm10 10h2v2h-2zm4-4h2v2h-2zm0-12h2v2h-2zm-4 12h2v2h-2zm4 4h2v2h-2z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgOption as Option };
